import * as React from "react";
import { BasePureComponent } from "./BaseComponent";
import { ChiamaAPI, Trad, Tipo, CampoNumero, InputImporto, InputPercentuale } from "./";
import * as Dati from "../Dati";
import * as DatiRCP from "../DatiRCP";
import * as Glob from "../Globale";
import { Garanzia } from "./Garanzia";

interface IProdottoProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON
    OnSetProdottoSelezionato: (compagnia: string) => void;
    Abilitato?: boolean;
    Forzabile?: boolean;
    NumeroFratelli?: number;
    HeaderVisible?: boolean;
    BodyVisible?: boolean;
    ShowOnlySelected?: boolean;
    OnChangeAppendice?: (e: React.FormEvent<any> | string, valore: any, label?: string, fieldTypeId?: number, elementGroup?: any) => any;
}

export class Prodotto extends BasePureComponent<IProdottoProps> {
    private _Prodotto: DatiRCP.CProdotto = new DatiRCP.CProdotto();
    private _Abilitato: boolean = true;
    private _Forzabile: boolean = false;
    private _DimensioneBig: number = 4;
    private _DimensioneSmall: number = 2;
    private _HeaderCSS: string = "";
    private _BodyCSS: string = "";

    public constructor(props: any) {
        super(props);
        this.OnAggiorna = this.OnAggiorna.bind(this);
        this.OnAggiornaGaranzie = this.OnAggiornaGaranzie.bind(this);
        this.OnBlurPremioNettoMaggiorato = this.OnBlurPremioNettoMaggiorato.bind(this);
        this.OnBlurFlessibilita = this.OnBlurFlessibilita.bind(this);
        this.OnBlurAccessori = this.OnBlurAccessori.bind(this);
        this.OnBlurScoperto = this.OnBlurScoperto.bind(this);
    }

    private Inizializza(props: IProdottoProps) {
        this._Abilitato = props.Abilitato != undefined ? props.Abilitato : true;
        this._Forzabile = props.Forzabile != undefined ? props.Forzabile : false;

        if (this.props.NumeroFratelli != undefined && this.props.NumeroFratelli > 2) {
            this._DimensioneBig = 6;
            this._DimensioneSmall = 6;
        } else {
            this._DimensioneBig = 6;
            this._DimensioneSmall = 4;
        }
    }

    private PopolaValori() {
        this._Prodotto = new DatiRCP.CProdotto();
        if (this.props.Value != undefined && this.props.Value != "") {
            if (typeof this.props.Value == "string") {
                this._Prodotto = Glob.DeserializzaOggettoNuovo(DatiRCP.CProdotto, this.props.Value);
            } else {
                this._Prodotto = this.props.Value;
            }
        } else {
            this._Prodotto = new DatiRCP.CProdotto();
        }

        if (this._Prodotto.PremioNettoMaggiorato == 0) {
            this._Prodotto.PremioNettoMaggiorato = this._Prodotto.CalcolaImportoNettoTotale();
            if (this._Prodotto.PremioNettoMaggiorato > 0) {
                //TODO Questa chiamata genera un warning perchè si crea un loop di chiamate render/setState quando viene selezionato per la prima volta un qualsiasi prodotto
                this.props.OnChange(this.props.Name, this._Prodotto);
            }
        }

        if (this._Prodotto.GaranziaBase.Selezionata) {
            this.props.OnSetProdottoSelezionato(this._Prodotto.Compagnia);
        }
    }

    private EsponiGaranzie(): React.ReactNode[] {
        let garanzie: React.ReactNode[] = [];
        garanzie.push(
            <Garanzia
                key={-1}
                Id={"Garanzia_B"}
                Name={"Garanzia_B"}
                OnChange={this.OnAggiornaGaranzie}
                Value={JSON.stringify(this._Prodotto.GaranziaBase)}
                Forzabile={this.props.Forzabile}
                Disabilitato={!this.props.Abilitato}
            />
        );

        for (let i: number = 0; i < this._Prodotto.GaranzieAccessorie.length; i++) {
            garanzie.push(
                <Garanzia
                    key={Number(i)}
                    Id={"Garanzia_" + Number(i)}
                    Name={"Garanzia_" + Number(i)}
                    OnChange={this.OnAggiornaGaranzie}
                    Value={JSON.stringify(this._Prodotto.GaranzieAccessorie[i])}
                    Forzabile={this.props.Forzabile}
                    Disabilitato={!this.props.Abilitato}
                />
            );
        }

        return garanzie;
    }

    private ColoreSfondo(): string {
        let semaforo: string = this._Prodotto.ColorePolizza();
        if (semaforo == DatiRCP.SemaforoRosso) return "bg-danger";
        else if (semaforo == DatiRCP.SemaforoGiallo) return "bg-warning";
        else return "bg-success";

        //if (this._Prodotto.NumeroGaranzieParziali() == this._Prodotto.GaranzieAccessorie.length + 1) {
        //    return "kt--bg-danger";
        //}
        //else if (this._Prodotto.NumeroGaranzieParziali() > 0 && this._Prodotto.NumeroGaranzieParziali() < this._Prodotto.GaranzieAccessorie.length + 1) {
        //    return "kt--kt-portlet__head";
        //}
        //else {
        //    return "kt--bg-success";
        //}
    }

    private ClassePulsante(): string {
        if (this._Prodotto.GaranziaBase.Selezionata) return "btn btn-success kt-btn kt-btn--icon kt-btn--outline-2x";
        else return "btn btn-outline-success kt-btn kt-btn--icon kt-btn--outline-2x";
    }

    private TestoPulsante(): string {
        if (this._Prodotto.GaranziaBase.Selezionata) return Trad.Trad("Selezionato");
        else return Trad.Trad("Seleziona");
    }

    private SelezionaProdotto(e: React.FormEvent<any>) {
        e.preventDefault();
        if (this._Abilitato) {
            this.props.OnSetProdottoSelezionato(this._Prodotto.Compagnia);
        }
    }

    protected OnAggiorna(e: React.FormEvent<any> | string, v: number): void {
        v = v * 1;
        if (typeof e == "string") {
            if (e == this.props.Name + "_PremioNettoMaggiorato") {
                this._Prodotto.PremioNettoMaggiorato = v;
            } else if (e == this.props.Name + "_Accessori") {
                this._Prodotto.Accessori = v;
            } else if (e == this.props.Name + "_Flessibilita") {
                this._Prodotto.Flessibilita = v;
            } else if (e == this.props.Name + "_Scoperto") {
                this._Prodotto.Scoperto = v;
            } else if (e == this.props.Name + "_ScopertoMax") {
                this._Prodotto.ScopertoMax = v;
            } else if (e == this.props.Name + "_ScopertoMin") {
                this._Prodotto.ScopertoMin = v;
            }

            this.props.OnChange(this.props.Name, this._Prodotto);
        }
    }

    protected OnAggiornaGaranzie(e: React.FormEvent<any> | string, v: Glob.DatiJSON): void {
        if (e == "Garanzia_B") {
            this._Prodotto.GaranziaBase = JSON.parse(v);
        } else {
            this._Prodotto.GaranzieAccessorie[Number(e.toString().replace("Garanzia_", ""))] = JSON.parse(v);
        }
        this.props.OnChange(this.props.Name, this._Prodotto);
    }

    private OnBlurPremioNettoMaggiorato(e: React.FormEvent<any> | string, v: number) {
        let PremioNettoTotale: number = this._Prodotto.CalcolaImportoNettoTotale();

        let modifica: boolean = false;

        if (this._Prodotto.PremioNettoMaggiorato < PremioNettoTotale && !this._Forzabile) {
            this._Prodotto.PremioNettoMaggiorato = PremioNettoTotale;
            modifica = true;
            Glob.InfoModaleWarning(Trad.Trad("PREMIONETTOMAGGIORATO"), Trad.Trad("PremioNettoMaggioratoNonPuoEssereMinoreDelPremioNettoStandard"));
        }

        if (modifica) {
            this.props.OnChange(this.props.Name, this._Prodotto);
        }
    }

    private OnBlurFlessibilita(e: React.FormEvent<any> | string, v: number) {
        let PremioNettoTotale: number = this._Prodotto.CalcolaImportoNettoTotale();

        let modifica: boolean = false;

        if (this._Prodotto.PremioNettoMaggiorato > PremioNettoTotale) {
            this._Prodotto.Flessibilita = 0;
            modifica = true;
            Glob.InfoModaleWarning(Trad.Trad("FLESSIBILITA"), Trad.Trad("NonSiPuoImpostareLaFlessibilitaSeLimportoEMaggiorato"));
        }

        if (this._Prodotto.Flessibilita > this._Prodotto.LimiteFlessibilita) {
            this._Prodotto.Flessibilita = this._Prodotto.LimiteFlessibilita;
            modifica = true;
            Glob.InfoModaleWarning(Trad.Trad("FLESSIBILITA"), Trad.Trad("SuperatoLimiteBinderFlessibilita"));
        }

        if (modifica) {
            this.props.OnChange(this.props.Name, this._Prodotto);
        }
    }

    private OnBlurAccessori(e: React.FormEvent<any> | string, v: number) {
        let modifica: boolean = false;

        if (this._Prodotto.Accessori > this._Prodotto.LimiteAccessori) {
            this._Prodotto.Accessori = this._Prodotto.LimiteAccessori;
            modifica = true;
            Glob.InfoModaleWarning(Trad.Trad("ACCESSORI"), Trad.Trad("SuperatoLimiteBinderAccessori"));
        }

        if (modifica) {
            this.props.OnChange(this.props.Name, this._Prodotto);
        }
    }

    private OnBlurScoperto(e: React.FormEvent<any> | string, v: number) {
        if (this._Prodotto.ScopertoMin != 0 && this._Prodotto.ScopertoMax != 0 && this._Prodotto.ScopertoMin > this._Prodotto.ScopertoMax) {
            Glob.InfoModaleWarning(Trad.Trad("WARNING SCOPERTO"), Trad.Trad("LoScopertoMaxDeveEssereMaggioreUgualeDelloScopertoMin"));
            this._Prodotto.ScopertoMax = this._Prodotto.ScopertoMin;
            this.props.OnChange(this.props.Name, this._Prodotto);
        }
    }

    private CSSColoreFont(premioNetto: number, premioNettoMaggiorato: number): string {
        if (premioNetto == premioNettoMaggiorato) return "TestoBiancoPremioNettoMaggiorato";
        else return "";
    }

    public render() {
        this.Inizializza(this.props);
        this.PopolaValori();

        if (this.props.HeaderVisible != undefined && !this.props.HeaderVisible) this._HeaderCSS = "hidden";
        else this._HeaderCSS = "";

        if (this.props.BodyVisible != undefined && !this.props.BodyVisible) this._BodyCSS = "hidden";
        else this._BodyCSS = "";

        let forzabile: any;
        if (this._Forzabile) {
            forzabile = (
                <div className={"row " + this._BodyCSS}>
                    <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                        <InputPercentuale
                            Name={this.props.Name + "_Scoperto"}
                            Id={this.props.Id + "_Scoperto"}
                            Valore={this._Prodotto.Scoperto}
                            Etichetta={Trad.Trad("Scoperto")}
                            OnChange={this.OnAggiorna}
                            OnChangeAppendice={this.props.OnChangeAppendice}
                            Scrittura={true}
                            Precisione={0}
                            Massimo={100}
                            Minimo={0}
                            Disabilitato={!this.props.Abilitato}
                        />
                    </div>
                    <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                        <InputImporto
                            Name={this.props.Name + "_ScopertoMin"}
                            Id={this.props.Id + "_ScopertoMin"}
                            Valore={this._Prodotto.ScopertoMin}
                            Etichetta={Trad.Trad("ScopertoMin")}
                            OnChange={this.OnAggiorna}
                            OnChangeAppendice={this.props.OnChangeAppendice}
                            Scrittura={true}
                            ValoreNeutro={0}
                            OnBlur={this.OnBlurScoperto}
                            Disabilitato={!this.props.Abilitato}
                        />
                    </div>
                    <div className={Glob.DimensioneCSS(4) + " kt-form login-form__group-sub"}>
                        <InputImporto
                            Name={this.props.Name + "_ScopertoMax"}
                            Id={this.props.Id + "_ScopertoMax"}
                            Valore={this._Prodotto.ScopertoMax}
                            Etichetta={Trad.Trad("ScopertoMax")}
                            OnChange={this.OnAggiorna}
                            OnChangeAppendice={this.props.OnChangeAppendice}
                            Scrittura={true}
                            ValoreNeutro={0}
                            OnBlur={this.OnBlurScoperto}
                            Disabilitato={!this.props.Abilitato}
                        />
                    </div>
                </div>
            );
        }
        return (
            <div className={"kt-portlet kt-portlet--head-overlay kt-portlet--rounded-force " + this.ColoreSfondo()}>
                <div className="kt-portlet__body">
                    <div className="kt-pricing-table-1">
                        <div className="kt-pricing-table-1__items row">
                            <div className="kt-pricing-table-1__item col-lg-12">
                                <div className="kt-pricing-table-1__visual">
                                    <img src={"/cdn/companies/logo_" + this._Prodotto.ID_BinderCompagnia + ".png"} alt="" width="10%" />
                                </div>
                                <span className="kt-pricing-table-1__icon kt--font-brand">
                                    <h3 className="kt-portlet__head-label kt--font-dark">{this._Prodotto.Compagnia}</h3>
                                </span>
                                <br />
                                <h2 className="kt-pricing-table-1__subtitle">Totale</h2>
                                <span className="kt-pricing-table-1__price">
                                    {" "}
                                    <h1>{Trad.TradParam("{1-I}", [this._Prodotto.CalcolaImportoLordoMaggiorato()])}</h1>
                                </span>
                                <span className={this._HeaderCSS}>{this.EsponiGaranzie()}</span>
                                <div className={"row paddingTab " + this._BodyCSS}>
                                    <div className={Glob.DimensioneCSS(12)}>
                                        <InputImporto
                                            Name={this.props.Name + "_PremioNetto"}
                                            Id={this.props.Id + "_PremioNetto"}
                                            Valore={this._Prodotto.CalcolaImportoNettoTotale()}
                                            Etichetta={Trad.Trad("PremioNetto")}
                                            OnChange={() => {}}
                                            Disabilitato={true}
                                        />
                                    </div>
                                </div>
                                <div className={"row paddingTab " + this._BodyCSS}>
                                    <div
                                        className={Glob.DimensioneCSS(this._DimensioneBig) + " " + this.CSSColoreFont(this._Prodotto.CalcolaImportoNettoTotale(), this._Prodotto.PremioNettoMaggiorato)}
                                    >
                                        <InputImporto
                                            Name={this.props.Name + "_PremioNettoMaggiorato"}
                                            Id={this.props.Id + "_PremioNettoMaggiorato"}
                                            Valore={this._Prodotto.PremioNettoMaggiorato}
                                            Etichetta={Trad.Trad("PremioNettoMaggiorato")}
                                            OnChange={this.OnAggiorna}
                                            OnChangeAppendice={this.props.OnChangeAppendice}
                                            OnBlur={this.OnBlurPremioNettoMaggiorato}
                                            Disabilitato={!this.props.Abilitato}
                                        />
                                    </div>
                                    <div className={Glob.DimensioneCSS(this._DimensioneBig)}>
                                        <InputPercentuale
                                            Name={this.props.Name + "_Accessori"}
                                            Id={this.props.Id + "_Accessori"}
                                            Valore={this._Prodotto.Accessori}
                                            Etichetta={Trad.Trad("Accessori")}
                                            OnChange={this.OnAggiorna}
                                            OnChangeAppendice={this.props.OnChangeAppendice}
                                            OnBlur={this.OnBlurAccessori}
                                            Scrittura={true}
                                            Massimo={this._Prodotto.LimiteAccessori}
                                            Disabilitato={!this.props.Abilitato}
                                        />
                                    </div>
                                    <div className={Glob.DimensioneCSS(this._DimensioneBig)}>
                                        <InputPercentuale
                                            Name={this.props.Name + "_Flessibilita"}
                                            Id={this.props.Id + "_Flessibilita"}
                                            Valore={this._Prodotto.Flessibilita}
                                            Etichetta={Trad.Trad("Flessibilita")}
                                            OnChange={this.OnAggiorna}
                                            OnChangeAppendice={this.props.OnChangeAppendice}
                                            OnBlur={this.OnBlurFlessibilita}
                                            Scrittura={true}
                                            Massimo={this._Prodotto.LimiteFlessibilita}
                                            Disabilitato={!this.props.Abilitato}
                                        />
                                    </div>
                                </div>
                                <div className={"row paddingTab " + this._BodyCSS}>
                                    <div className={Glob.DimensioneCSS(4)}>
                                        <InputImporto
                                            Name={this.props.Name + "_Imponibile"}
                                            Id={this.props.Id + "_Imponibile"}
                                            Valore={this._Prodotto.CalcolaImponibile()}
                                            Etichetta={Trad.Trad("Imponibile")}
                                            OnChange={() => {}}
                                            Disabilitato={true}
                                        />
                                    </div>
                                    <div className={Glob.DimensioneCSS(4)}>
                                        <InputImporto
                                            Name={this.props.Name + "_Tasse"}
                                            Id={this.props.Id + "_Tasse"}
                                            Valore={this._Prodotto.CalcolaTasse()}
                                            Etichetta={Trad.Trad("Tasse")}
                                            OnChange={() => {}}
                                            Disabilitato={true}
                                        />
                                    </div>
                                    <div className={Glob.DimensioneCSS(4)}>
                                        <InputImporto
                                            Name={this.props.Name + "_Lordo"}
                                            Id={this.props.Id + "_Lordo"}
                                            Valore={this._Prodotto.CalcolaImportoLordoMaggiorato()}
                                            Etichetta={Trad.Trad("Lordo")}
                                            OnChange={() => {}}
                                            Disabilitato={true}
                                        />
                                    </div>
                                </div>
                                {forzabile}
                                <button
                                    type="button"
                                    disabled={!this._Abilitato || this.props.ShowOnlySelected}
                                    className={this.ClassePulsante() + " " + this._BodyCSS}
                                    onClick={e => {
                                        this.SelezionaProdotto(e);
                                    }}
                                >
                                    <span>
                                        <span className="selezionaButton">{this.TestoPulsante()}</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Prodotto.tsx